<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/home">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <NavBar v-if="displayNavbarAndFooter"/>
    <div class="app__body">
      <router-view/>
    </div>
    <div class="ecm__footer" v-if="displayNavbarAndFooter">
      <div class="ecm__footer-logo">
        <h1 class="logo--title">BukuBook</h1>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import SocketIo from '@/config/socket'

export default {
  name: 'APP',
  components: {
    NavBar
  },
  data () {
    return {
      scrollPosition: 0,
      displayNavbar: true,
      displayNavbarAndFooter: true
    }
  },
  mounted () {
    this.handleConnectSocketIo()
    this.handleDisplayNavbarAndFooter(this.$route)
  },
  watch: {
    $route ($val) {
      this.handleDisplayNavbarAndFooter($val)
    }
  },
  methods: {
    handleConnectSocketIo () {
      const socket = new SocketIo()
      socket.connect()
    },
    handleDisplayNavbarAndFooter ($val) {
      if (['/register', '/login'].includes($val.path)) {
        this.$data.displayNavbarAndFooter = false
      } else {
        this.$data.displayNavbarAndFooter = true
      }
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
:root {
  --font-family: 'Poppins', sans-serif;
  --color-pink: #FF002E;
  --color-blue: #427df2;
  --color-yellow: yellow;
  --color-blue-background: #315baf;
  --color-grey-background: #eeeeeeb9;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: var(--font-family);
}

#app {
  // height: 300vh;
  .app__body {
    min-height: 100vh;
    // background: #F5F5F5;
  }
  .ecm__footer {
    background: var(--color-blue-background);
    padding: 10px;
    .ecm__footer-logo {
      font-weight: 500;
      font-size: 15px;
      text-align: center;
      h1 {
        font-size: 25px;
        color: white;
      }
    }
  }
}

.section__padding {
  padding: 35px 40px;
}

.section--title {
  font-size: 25px;
  font-weight: 550;
  letter-spacing: 1px;
}

.logo--title {
  color: var(--color-blue-background);
  font-weight: 600;
}

// @media screen and (max-width: 480px) {
//   .section__padding {
//     padding: 1rem .5rem;
//   }
//   #app {
//     // height: 300vh;
//     .app__body {
//       min-height: auto;
//     }
//   }
// }

/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
} */
</style>
